import { Games, Play, Translate } from '@nackle/arcade-core-v2';
import { Card, Button } from '@nackle/origami';
import React from 'react';
import { connect } from 'react-redux';
import './CabinetItem.less';
import { GameImage } from './GameImage';
import { getString } from '@nackle/intl-tools';
import { getUmbrellaImageUrl } from '../utils/umbrellaImageUrl';
import translationCache from '../../utils/cache';
// Locale-aware alt text component

import AltLocaleString from '../../components/AltLocaleString';
const mapStateToProps = ( state, props ) => {
  // get cabinet's alt text.
  const altTextTranslation =  getString( `cabinet.${ props.cabinet.romId }.alt` );

  return {
    cost: Games.getCabinetCost( state, props.cabinet.cabinetId, props.roomId ),
    playTokenIds: Play.getTokensIdsToPlay(
      state,
      props.cabinet.cabinetId,
      props.roomId,
    ),
    // if cabinet thumbnail alt text doesn't exist, use rom thumbnail alt text.
    altText: altTextTranslation
      ? altTextTranslation
      : getString( `rom.${ props.cabinet.romId }.alt` ),
  };
};

const mapDispatchToProps = {
  openGame: Play.openGame,
};

class CabinetItem extends React.Component {
  state = {
    cacheBundle: translationCache.mergedBundle,
  };

  unsubscribeTranslationCache = null;

  componentDidMount() {
    this.unsubscribeTranslationCache = translationCache.subscribe( ( mergedBundle ) => {
      this.setState( { cacheBundle: mergedBundle } );
    } );
  }

  componentWillUnmount() {
    if ( this.unsubscribeTranslationCache ) {
      this.unsubscribeTranslationCache();
    }
  }

  handleCardKeyDown = ( event ) => {
    if ( event.key === 'Enter' || event.key === ' ' ) {
      event.preventDefault();
      this.handleClick();
    }
  };

  render() {
    const { cabinet, cost, playTokenIds, tokenCount, isUmbrella } =
      this.props;
    const { cacheBundle } = this.state;
    const isDisabled = !playTokenIds;
    const playCount = Math.floor( tokenCount / cost );
    const romMeta = getString( `rom.${ cabinet.romId }.name` );
    const gameName = romMeta;
    const label = `${ gameName } (${ playCount })`;
    const cabinetImageSrc = getUmbrellaImageUrl(
      cabinet.image || cabinet.bannerImage,
      isUmbrella,
      '',
    );
    const romName = cacheBundle[ `rom.${ cabinet.romId }.name` ];
    return (
      <div className="gameCard-wrapper">
        <AltLocaleString code={ `rom.${ cabinet.romId }.alt` }>
          { ( altText ) => (
            <Card
              className={ `game-card ${ isDisabled ? 'disabled' : '' }` }
              id="game-name-link"
              aria-label={ label }
              role="button"
              aria-disabled={ isDisabled }
              tabIndex={ isDisabled ? -1 : 0 }
              onClick={ this.handleClick }
              onKeyDown={ this.handleCardKeyDown }
              cover={
                <div className="card-cover-wrapper">
                  <GameImage
                    alt={ altText }
                    src={ cabinetImageSrc }
                    className="card-image"
                  />
                </div>
              }
            >
              { /* Overlay inside the Card */ }
              <div className="card-overlay">
                <Button
                  type="primary"
                  shape="round"
                  className="play-button"
                  onClick={ this.handleClick }
                  disabled={ isDisabled }
                >
                  <Translate id={ 'arcade.webapp.playButton' }/>
                </Button>
              </div>
              <div className="game-title">{ romName }</div>
            </Card>
          ) }
        </AltLocaleString>
        { /* </button> */ }
      </div>
    );
  }

  handleClick = () => {
    const { cabinet, openGame, playTokenIds, roomId } = this.props;
    if ( playTokenIds && cabinet ) {
      openGame( cabinet.cabinetId, roomId ).catch( ( e ) => console.error( e ) );
    }
  };
}

export default connect( mapStateToProps, mapDispatchToProps )( CabinetItem );
